import React from 'react';
import { Switch } from '@/components/ui/switch';

export const StaffPermissionToggles = ({ user, available, onToggle }) => {
  const entries = Object.entries(available || {});
  if (entries.length === 0) return null;
  return (
    <div className="mt-3 pt-3 border-t border-[#F1F5F9] flex flex-wrap gap-5" data-testid={`qa-permissions-${user.email}`}>
      <span className="text-[11px] font-semibold uppercase tracking-widest text-[#64748B] self-center">Permissions</span>
      {entries.map(([key, label]) => (
        <label key={key} className="flex items-center gap-2 text-sm text-[#0F172A] cursor-pointer">
          <Switch
            checked={(user.permissions || []).includes(key)}
            onCheckedChange={(v) => onToggle(user, key, v)}
            data-testid={`qa-perm-${key}-${user.email}`}
          />
          {label}
        </label>
      ))}
    </div>
  );
};
